import { render, staticRenderFns } from "./thailandGoods.vue?vue&type=template&id=aa97ce6e&scoped=true"
import script from "./thailandGoods.vue?vue&type=script&lang=js"
export * from "./thailandGoods.vue?vue&type=script&lang=js"
import style0 from "./thailandGoods.vue?vue&type=style&index=0&id=aa97ce6e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa97ce6e",
  null
  
)

export default component.exports